import { render, staticRenderFns } from "./RecommendationsFormSteps.vue?vue&type=template&id=1c0f6e32"
import script from "./RecommendationsFormSteps.vue?vue&type=script&lang=js"
export * from "./RecommendationsFormSteps.vue?vue&type=script&lang=js"
import style0 from "./RecommendationsFormSteps.vue?vue&type=style&index=0&id=1c0f6e32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports